<template>
  <div class="py-6 px-8">
    <h-header :title="title">
      <template v-slot:actions>
        <v-btn
          @click="handleOpenRealEstateUserModal()"
          color="primary"
          elevation="0"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('realEstateUsers.label.newUser') }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <RealEstateUserFilters />

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="realEstateUsers"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('realty.table.noData')"
        :loading-text="$t('realty.table.loading')"
        @dblclick:row="showRealEstateUserRow"
        class="clickable"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span v-if="item.name">{{ item.name }}</span>
        </template>
        <template v-slot:[`item.real_estate.name`]="{ item }">
          <span v-if="item.real_estate.name">{{ item.real_estate.name }}</span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          {{ printRealEstateUserType(item.type) }}
        </template>
        <template v-slot:[`item.enabled`]="{ item }">
          <IconIsActive
            :isActive="item.enabled"
            :subtitle="$t(`realEstateUsers.isActive.${item.enabled}`)"
          />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <RealEstateUserMenu
            @showUser="showRealEstateUser"
            @editUser="editRealEstateUser"
            @deleteUser="deleteRealEstateUser"
            :user="item"
          />
        </template>
      </v-data-table>
    </v-card>

    <RightDrawer :moreInfo="false">
      <RealEstateUsersDetails />
    </RightDrawer>

    <RealEstateUserDelete />

    <h-pagination :fetch="fetchRealEstateUsers" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { realEstateUsersHeaders } from './listHeaders/realEstateUsersHeaders'

import RightDrawer from '@/components/app/RightDrawer'
import RealEstateUsersDetails from '@/components/realEstateUsers/RealEstateUsersDetails'
import RealEstateUserDelete from '@/components/realEstateUsers/RealEstateUserDelete'

import RealEstateUserIsTester from '@/components/realEstateUsers/RealEstateUserIsTester'
import IconIsActive from '@/components/IconIsActive'

import RealEstateUserFilters from '@/components/realEstateUsers/RealEstateUserFilters'
import RealEstateUserMenu from '@/components/realEstateUsers/fragments/RealEstateUserMenu'

export default {
  name: 'RealEstateUsersList',
  components: {
    RightDrawer,
    RealEstateUsersDetails,
    RealEstateUserDelete,
    RealEstateUserIsTester,
    IconIsActive,
    RealEstateUserFilters,
    RealEstateUserMenu,
  },

  data() {
    return {
      headers: realEstateUsersHeaders,
      title: this.$router.currentRoute.name,
    }
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'realEstateUser',
      'realEstateUsers',
      'itemsPerPage',
    ]),
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen']),

    ...mapActions([
      'openModal',
      'fetchRealEstateUser',
      'fetchRealEstateUsers',
      'handleOpenRealEstateUserModal',
      'handleOpenRealEstateUserDeleteModal',
    ]),

    showRealEstateUser(id) {
      this.setIsDrawerOpen(true)
      this.fetchRealEstateUser(id)
    },

    showRealEstateUserRow(event, { item }) {
      this.showRealEstateUser(item.id)
    },

    editRealEstateUser(id) {
      this.handleOpenRealEstateUserModal(id)
    },

    deleteRealEstateUser(id) {
      this.handleOpenRealEstateUserDeleteModal(id)
    },

    printRealEstateUserType(type) {
      if (!type) return '---'
      return this.$t(`roles.${type}`)
    },
  },

  mounted() {
    this.fetchRealEstateUsers()
  },
}
</script>
